import { RoleCode } from 'corso-types';
import { useStoreUser } from '~/providers/StoreUserProvider';
import useIsCorsoAdmin from './useIsCorsoAdmin';

/**
 * Use to determine is a user is a Corso or store admin.
 */
export default function useIsAdmin() {
  const isCorsoAdmin = useIsCorsoAdmin();
  const storeUser = useStoreUser();

  return isCorsoAdmin || storeUser.roleCode === RoleCode.admin;
}
